export default __webpack_public_path__ + "static/media/generation_z.09c508a7.svg";